module.exports = __webpack_public_path__ + "static/app-formato-transferencias-b79ef0ad19e35de4ef22c4e7fda75ad4.png";